import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {Customer} from '../../model/Entities/Customer';
import {Product} from '../../model/Entities/Product';
import {FormControl, Validators} from '@angular/forms';
import {numberValidator} from '../../validators/number.validator';
import {intValidator} from '../../validators/int.validator';
import {Contract} from '../../model/Entities/Contract';
import {CustomerService} from '../../services/customer.service';
import {CustomerContactPersonService} from '../../services/customer-contact-person.service';
import {Filter} from '../../model/Helpers/Filter';
import {CustomerContactPerson} from '../../model/Entities/CustomerContactPerson';
import {MailService} from '../../services/mail.service';
import {Email} from '../../model/Entities/Email';
import {SnackService} from '../../services/snack.service';
import {ConfigService} from '../../services/config.service';
import {UserService} from '../../services/user.service';

@Component({
    selector: 'contract-mail-dialog',
    templateUrl: './contract-mail.dialog.component.html',
    styleUrls: ['./contract-mail.dialog.component.scss']
})
export class ContractMailDialogComponent {

    private contract: Contract;
    public contactPersons: CustomerContactPerson[] = [];

    receiver: CustomerContactPerson;
    otherReceiver: string;
    senderEmail = 'noreply@maxstorage.ms';
    subject: string;
    content: string;

    // senderEmailFC = new FormControl({disabled: true}, [
    //     Validators.email,
    //     Validators.required
    // ]);

    subjectFC = new FormControl('', [
        Validators.required
    ]);

    constructor(public dialog: MatDialogRef<ContractMailDialogComponent>,
                private customerContactPersonService: CustomerContactPersonService,
                private userService: UserService,
                private mailService: MailService,
                private snackService: SnackService,
                public CONFIG: ConfigService,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        this.contract = data.contract;
        this.content = this.userService.getLoggedUser().emailSignature;
        if (this.userService.getLoggedUser().sendingEmail === '' || this.userService.getLoggedUser().sendingEmail == null)
            this.senderEmail = this.userService.getLoggedUser().email;
        else
            this.senderEmail = this.userService.getLoggedUser().sendingEmail;
        this.loadPersons();
    }

    loadPersons(): void {
        this.customerContactPersonService
            .getSimpleList([new Filter('customer_id', this.contract.customerId)])
            .subscribe((persons: CustomerContactPerson[]) => {
                this.contactPersons = persons;

                this.contactPersons.forEach((p: CustomerContactPerson) => {
                    if (p.id === this.contract.contactId) {
                        this.receiver = p;
                    }
                });
            });
    }

    checkValidity(): boolean {
        return this.subjectFC.valid && this.content != null;
    }

    submit(): void {
        const message: Email = new Email();
        message.subject = this.subject;
        message.message = this.content;
        if (!this.receiver) {
            message.recipient = '';
        } else {
            message.recipient = this.receiver.email;
        }
        message.recipient += ',' + this.otherReceiver;
        message.sender = this.senderEmail;
        message.contracts.push(this.contract.id);

        this.mailService.sendEmail(message).subscribe((e: Email) => {
            this.snackService.showSuccess(`Email "${e.subject}" byl odeslán na adresu ${e.recipient}`);
        });

        this.dialog.close(true);
    }
}



// WEBPACK FOOTER //
// /app/src/ContractsModule/ContractMailDialogComponent/contract-mail.dialog.component.ts